import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@forge/common";

import { ContextualMenuComponent } from "../../../../reusablecomponents/contextualmenu";
import ServiceActionComponent from "./ServiceAction";

import { IActionComponentProps } from "../../../../models/softwaredetails";
import { BASE_SOFTWARES, ServiceActions, SOFTWARE_ACTION_STATUS_MAP } from "../../../../utils/constants";

import "./index.scss";

const ActionComponent: React.FC<IActionComponentProps> = (props) => {
  const { t } = useTranslation();
  const [actionKey, setActionKey] = useState<string | null>(null);
  const [actionTrigger, setActionTrigger] = useState(0);
  const { status, softwareKey, disableGatewayActions } = props;

  const availableActions = useMemo(() => {
    if (!status) return [];
    
    const statusUpper = status.toUpperCase();
    const actions = SOFTWARE_ACTION_STATUS_MAP[statusUpper] || [];
    return actions;
  }, [status]);

  const filteredActions = useMemo(() => {
    const filtered = availableActions.filter(action => {
      if (action === ServiceActions.REINSTALL && !BASE_SOFTWARES.includes(softwareKey)) {
        return false;
      }
      return true;
    });
    
    return filtered;
  }, [availableActions, softwareKey]);

  const onMenuItemClick = (key: string) => {
    setActionKey(key);
    setActionTrigger(prev => prev + 1);
  };

  const getActionLabel = (action: string): string => {
    const labelMap: { [key: string]: string } = {
      [ServiceActions.INSTALL]: 'Install',
      [ServiceActions.UNINSTALL]: 'Uninstall',
      [ServiceActions.REINSTALL]: 'Edit/Reinstall',
      [ServiceActions.VIEWLOGS]: 'View Logs'
    };
    return labelMap[action] || action;
  };

  const menuItems = useMemo(() => {
    return filteredActions.map(action => ({
      id: `${action}-${softwareKey}`,
      label: getActionLabel(action),
      onClick: () => onMenuItemClick(action)
    }));
  }, [filteredActions, softwareKey]);

  const shouldShowMenu = !disableGatewayActions && filteredActions.length > 0;

  return (
    <>
      <div className="action-component">
        {shouldShowMenu ? (
          <ContextualMenuComponent
            menuItems={menuItems}
          />
        ) : (
          <Button 
            variant="quiet-primary"
            size="regular"
            disabled={true}
            className="service-action-btn"
          >
            ⋮
          </Button>
        )}
      </div>

      {actionKey && (
        <ServiceActionComponent
          {...props}
          actionKey={actionKey}
          actionTrigger={actionTrigger}
          isOpen={!!actionKey}
        />
      )}
    </>
  );
};

export default ActionComponent;